// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");

var ContentRect = {};

function create(cb) {
  return new ResizeObserver((function (v) {
                requestAnimationFrame(function (param) {
                      if (Array.isArray(v) && v.length > 0) {
                        return cb(v);
                      }
                      
                    });
              }));
}

var hasSupport = (function() { return window && !!window.ResizeObserver });

function useElementSize(elementRef) {
  var match = React.useState(function () {
        return [
                0,
                0
              ];
      });
  var setElementSize = match[1];
  React.useEffect((function () {
          var match = hasSupport();
          var match$1 = elementRef.current;
          if (!match) {
            return ;
          }
          if (match$1 === undefined) {
            return ;
          }
          var e = Caml_option.valFromOption(match$1);
          var observer = create(function (entries) {
                entries.forEach(function (e) {
                      setElementSize(function (param) {
                            return [
                                    e.contentRect.height,
                                    e.contentRect.width
                                  ];
                          });
                    });
              });
          observer.observe(e);
          return (function () {
                    observer.unobserve(e);
                  });
        }), [elementRef]);
  return match[0];
}

exports.ContentRect = ContentRect;
exports.create = create;
exports.hasSupport = hasSupport;
exports.useElementSize = useElementSize;
/* react Not a pure module */
